




















import type {
  Label, LabelId, Staff, Unit, Pixel,
} from '@/data';

import type { Image3DPageData } from '@/data/Source';
import LabelSvg from '@/vuejs/components/canvas/LabelSvg.vue';
import type { PropType } from 'vue';
import { defineComponent } from 'vue';

export default defineComponent({
  components: { LabelSvg },
  props: {
    pages: {
      type: Array as PropType<Array<Image3DPageData>>,
      default: undefined,
    },
    hasMargin: {
      required: true,
      type: Boolean,
    },
    sortedLabels: {
      required: true,
      type: Array as PropType<Label[]>,
    },
    pixelUnit: {
      required: true,
      type: Object as PropType<Unit<Pixel>>,
    },
    staves: {
      required: true,
      type: Array as PropType<Staff[]>,
    },
    selectedId: {
      default: null,
      type: Number as PropType<LabelId | null>,
    },
    isFocused: {
      required: true,
      type: Boolean,
    },
    currentViewX: {
      default: 0,
      type: Number,
    },
    currentPage: {
      type: Number,
      default: 0,
    },
    sourceType: {
      type: String,
      default: undefined,
    },
  },
});

